import WaitRipple from "components/WaitRipple";
import { useEffect, useState } from "react";
import { useStore } from "react-redux";
import { useAppDispatch, type IAppStore } from "src/utils/ReduxHooks";

let GeneralNotes = null;

let generalNotesDuck = null;

/**
 * 
 * @params {{userid: string}} props
 */
const GeneralNotesProxy = ({ userid }) => {
    const [ready, setReady] = useState(false);

    const store = useStore();
    const dispatch = useAppDispatch();

    import("src/teacherFeatures").then(features => {
        GeneralNotes = features.GeneralNotes;
        if (!(store as any).asyncReducers["generalNotes"]) {
            (store as any).injectReducer("generalNotes", features.GeneralNotesReducer);
        }

        generalNotesDuck = features.generalNotesDuck;

        setReady(true);
    });

    useEffect(() => {
        if (ready && userid) {
            dispatch(generalNotesDuck.getNotes(userid));
        }
    }, [ready, userid, dispatch]);

    if (!ready) {
        return <WaitRipple />;
    }
    else {
        return <GeneralNotes />
    }
}

export default GeneralNotesProxy;
